export const styles = {
  countdownContainer: {
    display: "flex",
    justifyContent: "center",
    mt: "20px",
    mb: "24px",
    mr: "10px",
  },
  spinner: {
    color: "events.bluePrimary",
  },
};
